import axios from '@/load_axios';
import moment from 'moment';

const API_HOST = window.BASE_URL ? window.BASE_URL : process.env.VUE_APP_HOSTNAME
const API_WP_BASE = `${API_HOST}/wp-json/wp/v2`
const API_BLAT_BASE = `${API_HOST}/wp-json/blat/v1`

export default {
    archive: {
        async all() {
            const res = await axios.get(`${API_BLAT_BASE}/archives`)
            let archives = res.data
            for(let archive of archives) {
                archive.month = parseInt(archive.month) - 1
                let a = moment().locale('pt').year(archive.year).month(archive.month)
                archive.format = a.format("MMMM YYYY")
            }
            return archives
        },
        async posts(year, month) {
            let posts = []
            if( month == null ) return
            try {
                const res = await axios.get(`${API_WP_BASE}/posts`, {params: {
                    per_page: 100,
                    after: new Date(year, month - 1, 1),
                    before: new Date(year, month, 1),
                }} )
                posts = res.data
            } catch(e) {
                console.log(e)
            }
            return posts
        },
    },
    footer: {
        async get() {
            const footerURL = `${API_BLAT_BASE}/footer`
            const res = await axios.get(footerURL)
            return res.data
        },
    },
    related: async (id, params) => {
        const res = await axios.get(`${API_HOST}/wp-json/contextual-related-posts/v1/posts/${id}/`, {params} )
        return res.data
    },
    search: async (query) => {
        const res = await axios.get(`${API_WP_BASE}/search`, {params: {search: query}} )
        return res.data
    },
    sponsors: {
        async all() {
            const res = await axios.get(`${API_BLAT_BASE}/sponsors`)
            return res.data
        },
    },
}

